export default "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAMCAYAAABr5z2BAAAAHElEQVR42mNgYGD4TyEGEuVk4lEDRg2grgEUYACbeQBkNirCbAAAAABJRU5ErkJggg=="